import styled from 'styled-components'

export const Container = styled.div`
  flex: 1;
  padding-top: env(safe-area-inset-top);
  background-color: ${({ theme }) => theme.colors.background};
`

export const MessageContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
`
export const MessageText = styled.span`
  font-size: 16px;
  text-align: center;
  color: ${({ theme }) => theme.colors.text};
`
